import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { isNullOrUndefined } from '../../models/utils';

export class KeyValueDataSource<T> extends DataSource<T> {
    private _data = new Array<T>();
    private _dataStream = new BehaviorSubject<(T)[]>(this._data);

    get data(): T[] {
        return this._data;
    }

    connect(collectionViewer: CollectionViewer): Observable<(T)[]> {
        return this._dataStream;
    }

    disconnect(): void {
        return;
    }

    set(items: T[]) {
        if (items) {
            this._data = items;
            this._dataStream.next(this._data);
        }
    }

    push(item: T, index?: number) {
        if (item) {
            if (isNullOrUndefined(index)) {
                this._data.push(item);
            } else {
                this._data.splice(index, 0, item);
            }
            this._dataStream.next(this._data);
        }
    }

    pop(): T {
        const ret = this._data.pop();
        this._dataStream.next(this._data);
        return ret;
    }

    splice(start: number, deleteCount: number): T[] {
        const ret = this._data.splice(start, deleteCount);
        this._dataStream.next(this._data);
        return ret;
    }
}
